import createReactComponent from '../createReactComponent';
var PowerOff = createReactComponent('PowerOff', [['path', {
  d: 'M18.36 6.64A9 9 0 0120.77 15M5.63 6.64A9 9 0 1018.706 19',
  key: '1t83n5'
}], ['path', {
  d: 'M12 2v4',
  key: '3427ic'
}], ['path', {
  d: 'M2 2l20 20',
  key: '48x37f'
}]]);
export default PowerOff;